import React, { useEffect, useState } from 'react';

// styling
import { Colors } from '_styles';

const PaxAssignmentText = (props) => {

    let formattedTime = props?.flightTime;
    formattedTime = new Date(formattedTime).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
    return (
        <div>
            <p>You have selected to assign {" "}
                <span style={{ color: Colors.PRM_LIGHT_BLUE }}>{props?.selectedName}</span>
                {" "}on{" "}
                <span style={{ color: Colors.PRM_LIGHT_BLUE }}>{props?.flightNumber} ({props?.originAirport + ' - ' + props?.destinationAirport}) </span>
                {" "}at{" "}
                <span style={{ color: Colors.PRM_LIGHT_BLUE }}>{formattedTime}</span>
                {" "}to{" "}
                <span style={{ color: Colors.PRM_LIGHT_BLUE }}>{props?.selectedEmployee?.title}</span>
                {" "}at{" "}
                <span style={{ color: Colors.PRM_LIGHT_BLUE }}>{props?.assignedTime}</span>
            </p>
        </div>
    );
};

export default PaxAssignmentText;
